import { render } from "./Validation.vue?vue&type=template&id=eb4c6fea"
import script from "./Validation.vue?vue&type=script&lang=js"
export * from "./Validation.vue?vue&type=script&lang=js"
script.render = render

export default script